export default "__VITE_ASSET__qhovd3M$__"